<template>
  <div>
    <h3>铭牌管理</h3>
    <el-form inline :model="form">
      <el-form-item label="铭牌名称">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addBadge">新增铭牌</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border style="margin-top:20px">
      <el-table-column prop="id" label="ID"/>
      <el-table-column prop="name" label="铭牌名称"/>
      <el-table-column prop="createdAt" label="创建时间"/>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="danger" @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {getBadgeList,addBadge,delBadge} from "../api";
export default {
  data(){
    return {
      tableData:[],
      form:{name:''}
    }
  },
  mounted(){
    this.load()
  },
  methods:{
    async load(){
      const res = await getBadgeList()
      this.tableData = res.data.list
    },
    async addBadge(){
      await addBadge(this.form)
      this.$message.success('添加成功')
      this.form.name=''
      this.load()
    },
    async del(id){
      await delBadge(id)
      this.$message.success('已删除')
      this.load()
    }
  }
}
</script>
